// ** Dropdowns Imports
import IntlDropdown from './IntlDropdown'
//import CartDropdown from './CartDropdown'
import UserDropdown from './UserDropdown'
import NavbarSearch from './NavbarSearch'
import NotificationDropdown from './NotificationDropdown'
import NavbarBalance from './NavbarBalance/NavbarBalance'
import CartDropdown from './CartDropdown'
import { isUserLoggedIn } from '@utils'

// ** Third Party Components
import {
  Menu,
  Sun,
  Moon,
  ToggleLeft,
  ToggleRight,
  HelpCircle,
  MessageCircle
} from 'react-feather'
import { NavItem, NavLink, Button } from 'reactstrap'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { handleMenuCollapsed } from '@src/redux/actions/layout'
import { ReactComponent as Whatsapp } from '@src/assets/images/icons/whatsapp.svg'
// ** Custom hooks
import useWindowDimensions from '@hooks/useWindowDimensions'
import { openInNewTab } from '@src/utility/Utils'

const NavbarUser = (props) => {
  // ** Props
  const { skin, setSkin } = props

  // ** Redux state
  const { menuCollapsed } = useSelector((state) => state.layout)

  const { isMobile } = useWindowDimensions()

  const dispatch = useDispatch()
  const history = useHistory()

  const setMenuCollapsed = (val) => dispatch(handleMenuCollapsed(val))

  // ** Function to toggle Theme (Light/Dark)
  // const ThemeToggler = () => {
  //   if (skin === 'dark') {
  //     return <Sun className="ficon" onClick={() => setSkin('light')} />
  //   } else {
  //     return <Moon className="ficon" onClick={() => setSkin('dark')} />
  //   }
  // }

  const NavbarToggler = () => {
    if (menuCollapsed) {
      return (
        <ToggleLeft
          className="ficon"
          onClick={() => setMenuCollapsed(!menuCollapsed)}
        />
      )
    } else {
      return (
        <ToggleRight
          className="ficon"
          onClick={() => setMenuCollapsed(!menuCollapsed)}
        />
      )
    }
  }

  // Green Button
  // const WhatsappButton = () => {
  //   return (
  //     <Button.Ripple
  //       size="sm"
  //       color="success"
  //       className="btn-icon d-flex align-items-center"
  //       style={{ gap: '0.5rem' }}
  //       onClick={() =>
  //         openInNewTab(
  //           `https://api.whatsapp.com/send?phone=5511930390062&text=${encodeURI(
  //             'Olá! Gostaria de saber mais sobre os produtos da BeUni =)'
  //           )}`
  //         )
  //       }
  //     >
  //       <Whatsapp style={{ width: '18px', height: '18px' }} fill="#fff" />
  //       {!isMobile && (
  //         <span style={{ marginTop: '3px' }}>Fale com um especialista</span>
  //       )}
  //     </Button.Ripple>
  //   )
  // }

  // const WhatsappButton = () => {
  //   return (
  //     <NavLink
  //       size="sm"
  //       className="nav-link-style tw-group"
  //       style={{ gap: '0.5rem' }}
  //       onClick={() =>
  //         openInNewTab(
  //           `https://api.whatsapp.com/send?phone=5511930390062&text=${encodeURI(
  //             'Olá! Gostaria de saber mais sobre os produtos da BeUni =)'
  //           )}`
  //         )
  //       }
  //     >
  //       <Whatsapp style={{ width: '21px', height: '21px' }} fill='currentColor' className='group-hover:tw-text-[#f45e18]' /> {' '}
  //       {!isMobile && (
  //         <span style={{ marginTop: '3px' }}>Fale com um especialista</span>
  //       )}
  //     </NavLink>
  //   )
  // }

  return (
    <ul
      className="nav navbar-nav align-items-center ml-auto"
      aria-label="user navegation"
    >
      {/* <IntlDropdown /> */}
      {/* <NavItem className="d-lg-block">
        <WhatsappButton />
      </NavItem> */}
      <NavItem className="d-lg-block px-16">
        <NavLink
          onClick={() => history.push('/faq')}
          className="nav-link-style tw-group"
        >
          <MessageCircle className="ficon group-hover:!tw-text-[#FF5600]" />{' '}
          {isMobile ? '' : 'Atendimento Online'}
        </NavLink>
      </NavItem>
      {/* <NavItem className="d-lg-block">
        <NavLink className="nav-link-style">
          <ThemeToggler />
        </NavLink>
      </NavItem> */}

      <NavItem className="d-lg-block">
        <CartDropdown />
      </NavItem>

      {/* <NavbarSearch /> */}
      <NavItem className="d-lg-block">
        {isUserLoggedIn() ? (
          <UserDropdown />
        ) : (
          <li className={'dropdown-user nav-item'}>
            <Button
              tag="a"
              className="user-nav d-sm-flex ml-1"
              color={'primary'}
              onClick={() => {
                history.push('/login')
              }}
            >
              Login
            </Button>
          </li>
        )}
      </NavItem>

      {!isUserLoggedIn() && (
        <NavItem className="d-lg-block">
          <li className={'dropdown-user nav-item'}>
            <Button
              tag="a"
              className="user-nav d-sm-flex ml-1"
              color={'secondary'}
              onClick={() => {
                history.push('/register')
              }}
            >
              Cadastro
            </Button>
          </li>
        </NavItem>
      )}

      {/* <NotificationDropdown /> */}
      {/* <NavItem>
        <NavbarBalance />
      </NavItem> */}
    </ul>
  )
}
export default NavbarUser
